import { render, staticRenderFns } from "./setting-branch.vue?vue&type=template&id=a3c26a0e&scoped=true"
import script from "./setting-branch.vue?vue&type=script&lang=js"
export * from "./setting-branch.vue?vue&type=script&lang=js"
import style0 from "./setting-branch.vue?vue&type=style&index=0&id=a3c26a0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c26a0e",
  null
  
)

export default component.exports